import { install } from './components';

export * from './components';
export * from './user';
export * from './store';

export default { install };
